import { useGlobalKeyboardShortcuts } from 'hooks/useGlobalKeyboardShortcuts';

/**
 * Composant pour gérer les raccourcis clavier globaux
 * Doit être placé à l'intérieur du Router pour utiliser useNavigate
 */
const GlobalKeyboardShortcuts = () => {
    useGlobalKeyboardShortcuts();
    return null; // Ce composant ne rend rien
};

export default GlobalKeyboardShortcuts;
